// extracted by mini-css-extract-plugin
module.exports = {"list":"pagenav_list__rJp9G","item":"pagenav_item__8ZVqI"};